<template>
    <div class="main">
        <c-panel title="BUSCA ATIVA — INFREQUÊNCIA" titleIcon="fas fa-search-location">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Alunos que bateram alguma regra de infrequência, com as datas exatas das faltas."
                description="A janela é contada em dias letivos da escola: feriados e recessos não entram. A avaliação roda diariamente e também pode ser disparada aqui."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregar">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" class="u-text-right u-mt-25">
                        <el-button v-if="podeEscrever" type="primary" size="small" icon="el-icon-refresh" @click="avaliar">
                            AVALIAR AGORA
                        </el-button>
                        <el-button class="u-ml-10" size="small" icon="el-icon-data-analysis" @click="verResumo">RESUMO</el-button>
                        <el-button class="u-ml-10" size="small" icon="el-icon-printer" @click="imprimir">IMPRIMIR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="resumoRelatorio" type="info" :closable="true" class="u-mb-15"
                @close="resumoRelatorio = null"
                :title="'Recorte filtrado: ' + resumoRelatorio.total + ' alerta(s)'"
                :description="resumoTexto"></el-alert>

            <!-- ==================== KPIs ==================== -->
            <el-row v-if="painel" :gutter="10" class="u-mb-20">
                <el-col :xs="12" :sm="4"><div class="kpi kpi-aberto"><span class="n">{{ painel.kpis.abertos }}</span><span class="r">Abertos</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-tratativa"><span class="n">{{ painel.kpis.em_tratativa }}</span><span class="r">Em tratativa</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-resolvido"><span class="n">{{ painel.kpis.resolvidos }}</span><span class="r">Resolvidos</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-encaminhado"><span class="n">{{ painel.kpis.encaminhados }}</span><span class="r">Encaminhados</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi kpi-reincidente"><span class="n">{{ painel.kpis.reincidentes }}</span><span class="r">Reincidentes</span></div></el-col>
                <el-col :xs="12" :sm="4"><div class="kpi"><span class="n">{{ painel.kpis.total }}</span><span class="r">Total</span></div></el-col>
            </el-row>

            <!-- ==================== FILTROS DA LISTA ==================== -->
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="8">
                    <el-input v-model="filtro.aluno" size="small" placeholder="Pesquisar aluno..." @keyup.native.enter="carregarAlertas"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.situacao" clearable size="small" placeholder="Situação" style="width: 100%;" @change="carregarAlertas">
                        <el-option v-for="s in situacoes" :key="s" :value="s" :label="rotuloSituacao(s)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.severidade" clearable size="small" placeholder="Severidade" style="width: 100%;" @change="carregarAlertas">
                        <el-option value="baixa" label="Baixa"></el-option>
                        <el-option value="media" label="Média"></el-option>
                        <el-option value="alta" label="Alta"></el-option>
                    </el-select>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Aluno</th>
                            <th style="width: 110px;" class="hidden-mobile">Turma</th>
                            <th style="width: 160px;">Regra</th>
                            <th style="width: 70px;" class="u-text-center">Faltas</th>
                            <th style="width: 180px;">Datas das faltas</th>
                            <th style="width: 120px;" class="u-text-center">Situação</th>
                            <th style="width: 130px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="a in alertas" :key="a.id">
                            <td>
                                {{ a.aluno }}
                                <div v-if="a.num_matricula"><small class="u-text-muted">{{ a.num_matricula }}</small></div>
                            </td>
                            <td class="hidden-mobile">{{ a.turma }}</td>
                            <td>
                                {{ a.regra }}
                                <div><el-tag size="mini" :type="corSeveridade(a.severidade)">{{ a.severidade }}</el-tag></div>
                            </td>
                            <td class="u-text-center">{{ a.qtd_faltas }}</td>
                            <td>
                                <small>{{ datasFaltas(a) }}</small>
                                <div><small class="u-text-muted">janela {{ dataBr(a.janela_inicio) }} a {{ dataBr(a.janela_fim) }}</small></div>
                            </td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="corSituacao(a.situacao)">{{ rotuloSituacao(a.situacao) }}</el-tag>
                                <div v-if="a.intervencao_aluno_id"><small class="u-text-muted">intervenção aberta</small></div>
                            </td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever" size="mini" plain @click="abrirTratativa(a)">TRATAR</el-button>
                                <el-button class="u-ml-10" size="mini" type="text" icon="el-icon-printer" title="Ofício ao Conselho Tutelar"
                                    @click="imprimirOficio(a)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="alertas.length === 0"><td colspan="7" class="u-text-center">Nenhum alerta para os filtros informados.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <!-- ==================== TRATATIVA ==================== -->
            <el-dialog title="Tratar alerta" :visible.sync="dialogo" width="560px">
                <el-alert v-if="atual" type="info" :closable="false" class="u-mb-15"
                    :title="atual.aluno + ' — ' + atual.turma"
                    :description="atual.qtd_faltas + ' falta(s) entre ' + dataBr(atual.janela_inicio) + ' e ' + dataBr(atual.janela_fim)"></el-alert>

                <el-form label-position="top">
                    <el-form-item label="Situação">
                        <el-select v-model="form.situacao" style="width: 100%;">
                            <el-option v-for="s in situacoes" :key="s" :value="s" :label="rotuloSituacao(s)"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item :label="exigeProvidencia ? 'Providência adotada (obrigatória)' : 'Providência adotada'">
                        <el-input v-model="form.providencia" type="textarea" :rows="4"
                            placeholder="Ex.: contato telefônico com a responsável; aluna retornou em 12/03."></el-input>
                    </el-form-item>

                    <el-checkbox v-if="atual && !atual.intervencao_aluno_id" v-model="form.abrir_intervencao">
                        Abrir intervenção pedagógica para este aluno
                    </el-checkbox>
                </el-form>

                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="tratar">REGISTRAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO I — item 131: painel e tratativa da busca ativa. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        statusList: true, instituicaoId: null, periodoId: null,
        instituicoes: [], painel: null, alertas: [],
        filtro: { aluno: '', situacao: '', severidade: '' },
        situacoes: ['aberto', 'em_tratativa', 'resolvido', 'encaminhado'],
        dialogo: false, atual: null, resumoRelatorio: null,
        form: { situacao: 'em_tratativa', providencia: '', abrir_intervencao: false }
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        exigeProvidencia () {
            return ['resolvido', 'encaminhado'].indexOf(this.form.situacao) !== -1
        },
        resumoTexto () {
            if (!this.resumoRelatorio) return ''
            const p = this.resumoRelatorio.por_situacao
            return Object.keys(p).map(k => `${this.rotuloSituacao(k)}: ${p[k]}`).join(' · ')
        }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id }

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (Array.isArray(r.data) && r.data.length) this.instituicoes = r.data })
         .catch(() => {}).then(() => this.carregar())
    },
    methods: {
        carregar () {
            this.painel = null
            if (!this.instituicaoId || !this.periodoId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/busca-ativa/painel/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.painel = r.data
            }).catch(e => this.$store.commit('throwException', e))

            this.carregarAlertas()
        },
        carregarAlertas () {
            if (!this.instituicaoId) return
            this.statusList = false

            const payload = Object.assign({}, this.filtro, {
                instituicao_id: this.instituicaoId, periodo_letivo_id: this.periodoId
            })

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/busca-ativa/getAlertasPaginate?page=1`,
                payload, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.statusList = true
                    return
                }
                this.alertas = r.data.data || []
                this.statusList = true
            }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        avaliar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/busca-ativa/avaliar`,
                { periodo_letivo_id: this.periodoId, instituicao_id: this.instituicaoId },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }

                let msg = `${r.data.alertas_criados} alerta(s) criado(s) em ${r.data.matriculas_avaliadas} matrícula(s) avaliada(s).`
                if (r.data.aviso) msg += ' ' + r.data.aviso

                window.eventBus.$emit('alert', { msg: msg, type: r.data.aviso ? 'warning' : 'success' })
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        abrirTratativa (a) {
            this.atual = a
            this.form = { situacao: 'em_tratativa', providencia: a.providencia || '', abrir_intervencao: false }
            this.dialogo = true
        },
        tratar () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/busca-ativa/tratarAlerta/${this.atual.id}`,
                this.form, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        /**
         * Resumo por situação do recorte filtrado. É o mesmo conteúdo do relatório
         * impresso — exibido na tela antes de gerar o PDF, para o operador conferir o
         * que vai sair.
         */
        verResumo () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/busca-ativa/relatorio`,
                { instituicao_id: this.instituicaoId, periodo_letivo_id: this.periodoId,
                  situacao: this.filtro.situacao }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.resumoRelatorio = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        imprimir () {
            window.eventBus.$emit('print', {
                url: '/api/busca-ativa/imprimirRelatorio',
                param: { instituicao_id: this.instituicaoId, periodo_letivo_id: this.periodoId,
                         situacao: this.filtro.situacao }
            })
        },
        imprimirOficio (a) {
            window.eventBus.$emit('print', { url: `/api/busca-ativa/imprimirOficio/${a.id}`, param: {} })
        },
        datasFaltas (a) {
            const d = typeof a.datas_faltas === 'string' ? JSON.parse(a.datas_faltas) : a.datas_faltas
            if (!Array.isArray(d)) return '—'
            return d.map(x => this.dataBr(x).substring(0, 5)).join(', ')
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        rotuloSituacao (s) {
            return { aberto: 'Aberto', em_tratativa: 'Em tratativa', resolvido: 'Resolvido',
                encaminhado: 'Encaminhado' }[s] || s
        },
        corSituacao (s) {
            return { aberto: 'danger', em_tratativa: 'warning', resolvido: 'success', encaminhado: 'info' }[s] || 'info'
        },
        corSeveridade (s) { return { baixa: 'info', media: 'warning', alta: 'danger' }[s] || 'info' },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.kpi .n { display: block; font-size: 22px; font-weight: bold; }
.kpi .r { display: block; font-size: 11px; color: #606266; }
.kpi-aberto { border-left: 4px solid #f56c6c; }
.kpi-tratativa { border-left: 4px solid #e6a23c; }
.kpi-resolvido { border-left: 4px solid #67c23a; }
.kpi-encaminhado { border-left: 4px solid #409eff; }
.kpi-reincidente { border-left: 4px solid #8e44ad; }
</style>
